import type {
  BasketItem,
  Product,
  PromotionEffect,
  Variant,
} from '@scayle/storefront-nuxt'
import { useProductPrice } from '#storefront/composables'

export function getTotalStrikeThroughPrices(
  item: BasketItem<Product, Variant, PromotionEffect>,
) {
  const { appliedReductions } = useProductPrice(() => item.price.total)
  return appliedReductions.value.reduce(
    (sum, p) => sum + p.amount.absoluteWithTax,
    0,
  )
}
